// extracted by mini-css-extract-plugin
export var cardIcon = "_4u-4";
export var checkboxCard = "_4u-0";
export var checkboxCardSelected = "_4u-3";
export var disabled = "_4u-1";
export var outerBorder = "_4u-2";
export var spacerMedium = "_4u-7";
export var spacerSmall = "_4u-6";
export var spacerXsmall = "_4u-5";